<template>
    <div class="all clearfix">
        <div class="trans pt0">
           <div class="grid pb30">
                <div class="search-warp w737">
                    <!-- <button class="search-btn fr" @click="KeyUpEsc">查询</button>  -->
                    <div class="hidden">
                        <input type="text" v-model="keywords" @keyup.enter="KeyUpEsc" placeholder="输入关键词" class="input-text ac">
                    </div>
                </div>
                <div class="warp mt5 clearfix">
                    <div class="warp-body">
                        <div class="artiWrap h680 hidden">
                            <d3chart id="d3Svg" width="100%" height="680" ref="d3" :ds="dsCharts" :updateDs="updateDsCharts" @entityFatherMethod="getEntityChild"></d3chart>
                            <div class="no-data mt0 pt40" v-if="nodata.knowEntity"><img src="static/images/no_data.png" class="img"/><span class="text crff">啥也没有找到，换个词试试吧~</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import d3chart from '../components/d3Chart.vue'
export default {
    components: {d3chart},
    data() {
        return {
            keywords:'舆情', //搜索关键词
            dsCharts:[],
            updateDsCharts:[],
            nodata:{
                knowEntity:false,
            }
        }
    },
    mounted() {
		let that = this;
        that.getEntity();
    },
    methods: {
        //搜索知识图谱
        KeyUpEsc(){
            let that = this;
            that.dsCharts = [];
            that.nodata.knowEntity = false;
            that.getEntity();
        },
        getEntity(){
            let that = this,item = that.keywords;
            let datas = {
                entity:item
            };
            that.$api.get('news/knowledge/name',datas, r => {
                that.$parent.returnCode(r,function(){
                    let data = r.data;
                    if(data.length<=0){
                        if(that.dsCharts.length<=0){
                            that.nodata.knowEntity = true;
                        }
                        return;
                    }
                    let nodeJson = {
                        nodes:[],
                        links:[],
                    }
                    if(data[0][1]!=item){
                        nodeJson.nodes.push({name:item})
                    }
                    
                    if(data.length>0){
                        data.forEach((ele,i) => {
                            if(ele[1] == '') return
                            let name = ele[1];
                            if(i>0 && ele[1] == data[i-1][1] ){
                                name = ele[1]+"("+ele[0] + ")"
                                //return
                            }
                            let tmp = {};
                            let tmp1 = {};
                            tmp.name = name;
                            tmp.id = ele[2];
                            nodeJson.nodes.push(tmp)
                            tmp1.source = item;
                            tmp1.target = name;
                            tmp1.relation = ele[0];
                            nodeJson.links.push(tmp1)
                        });
                    }
                    that.dsCharts = nodeJson;
                    //console.log(that.dsCharts);
                })
            }) 
        },
        getEntityChild(item,id){
            let that = this;
            let datas = {
                node_id:id,
            };
            that.$api.get('news/knowledge/node-id',datas, r => {
                that.$parent.returnCode(r,function(){
                    let data = r.data;
                    let nodeJson = {
                        nodes:[],
                        links:[],
                    }
                    // if(data[0][1]!=item){
                    //     nodeJson.nodes.push({name:item})
                    // }
                    if(data.length>0){
                        data.forEach((ele,i) => {
                            if(ele[1] == '') return
                            let name = ele[1];
                            if(i>0 && ele[1] == data[i-1][1] ){
                                name = ele[1]+"("+ele[0] + ")"
                                //return
                            }
                            let tmp = {};
                            let tmp1 = {};
                            tmp.name = name;
                            tmp.id = ele[2];
                            nodeJson.nodes.push(tmp)
                            tmp1.source = item;
                            tmp1.target = name;
                            tmp1.relation = ele[0];
                            nodeJson.links.push(tmp1)
                        });
                    }
                    that.updateDsCharts = nodeJson;
                })
            }) 
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/knowledge.vue